import { makeRequest } from 'utils/requestLogger';

export default (id, assessments) =>
    makeRequest('put', `/api/submissions/${id}/draft-assessments`, assessments);



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/submission/saveDraftAssessment.js